import { MdOutlineArrowLeft, MdOutlineArrowRight } from 'react-icons/md'

import { InternalLink } from 'src/components/atoms/Link'

import { blogPath, viewBlogPostPath } from 'src/config/paths'

export interface PostNavigationProps {
  lastPostSlug?: string
  nextPostSlug?: string
}

export const PostNavigation = ({
  lastPostSlug,
  nextPostSlug
}: PostNavigationProps) => {
  return (
    <div className='flex justify-between items-center'>
      {lastPostSlug ? (
        <InternalLink
          className='flex items-center text-center'
          href={viewBlogPostPath({ routeParams: { slug: lastPostSlug } })}
        >
          <MdOutlineArrowLeft size='30' />
          <span>Previous</span>
        </InternalLink>
      ) : (
        <div />
      )}
      <InternalLink className='text-center' href={blogPath()}>
        All posts
      </InternalLink>
      {nextPostSlug ? (
        <InternalLink
          className='flex items-center text-center'
          href={viewBlogPostPath({ routeParams: { slug: nextPostSlug } })}
        >
          Next
          <MdOutlineArrowRight size='30' />
        </InternalLink>
      ) : (
        <div />
      )}
    </div>
  )
}
